import {
  ShaqFAQ,
} from '../models/Objects';

export class StoreState {
  faqs: Map<number, ShaqFAQ> = new Map();
  currentFAQ: (ShaqFAQ | null) = null;
}

export const state: StoreState = new StoreState();
